import React, { memo, useRef } from 'react';
import classNames from 'classnames';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import Editor from '@components/richEditor/richEditor';
import { RICH_TYPE } from '@components/richEditor/configs';
import { useDebounce } from '@components';

function LeafContent({
  isExpand,
  isEditing,
  setEditingId,
  order,
  updateDataCollection,
  location,
  noTitle,
  formChange = () => {},
  ...restProps
}) {
  const debouncedUpdataCollection = useDebounce(
    (contentState, noListStyle, oldHtmlContent, oldNoListStyle) => {
      const contentRaw = convertToRaw(contentState);
      const newHtmlContent = draftToHtml(contentRaw);

      // if (oldHtmlContent !== newHtmlContent || noListStyle !== oldNoListStyle) {
      updateDataCollection({
        payload: {
          richContent: {
            contentSource: contentRaw,
            config: {
              noListStyle,
            },
          },
          htmlContent: newHtmlContent,
        },
        location,
      });
      // }
    },
    300,
  );

  const editorRef = useRef();
  // if no title presented, content should show as title speed
  const animationDelay = noTitle ? `${order - 0.5}s` : `${order + 0.5}s`;

  const handleDoubleClick = () => {
    if (editorRef.current?.focus) {
      editorRef.current.focus();
    }
    setEditingId();
  };

  const wrapperClassName = classNames('leaf-content-animation-wrapper', {
    opened: isExpand,
    'no-title': noTitle,
  });
  const contentClassName = classNames('leaf-content', {
    'editing-content': isEditing,
    opened: isExpand,
    closed: !isExpand,
  });
  return (
    <div className={wrapperClassName}>
      {/* style={{ animationDelay }} */}
      <div className="border-mask" />
      {/* style={{ animationDelay }} */}
      <div onDoubleClick={handleDoubleClick} className={contentClassName}>
        <Editor
          {...restProps}
          readOnly={!isEditing}
          ref={editorRef}
          updateDataCollection={debouncedUpdataCollection}
          richTypes={[RICH_TYPE.UNORDERED_LIST, RICH_TYPE.LINK]}
          formChange={formChange}
        />
      </div>
    </div>
  );
}

export default memo(LeafContent);
